import React from 'react';
import { Bone, Card, Row, Col, Container } from './SkeletonPulse';

const DashboardSkeleton = () => (
  <Container style={{ paddingTop: 12, paddingBottom: 40 }}>
    {/* Suggestion card */}
    <Card style={{ marginBottom: 16 }}>
      <Col gap={14}>
        {/* Category badge */}
        <Bone width={90} height={22} radius={12} />
        {/* Title */}
        <Bone width="85%" height={18} />
        {/* Description lines */}
        <Col gap={8}>
          <Bone width="100%" height={13} />
          <Bone width="95%" height={13} />
          <Bone width="60%" height={13} />
        </Col>
        {/* Action buttons row */}
        <Row gap={10} style={{ paddingTop: 8 }}>
          <Bone width={120} height={32} radius={16} />
          <Bone width={100} height={32} radius={16} />
        </Row>
      </Col>
    </Card>

    {/* Hold-to-complete button */}
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 8 }}>
      <Bone width={200} height={52} radius={26} />
    </div>
  </Container>
);

export default DashboardSkeleton;
